// @ts-nocheck
import { FormModel } from "@store/Framework/Store/Starter/Components/Form/FormTypes";
import { createContext, useContext } from "react";

export const formContextInitialValue = {
    id: "",
    inputs: [],
    hasAlreadyError: false,
};

export const FormContext = createContext<FormModel>(formContextInitialValue);
export const useFormContext = () => useContext(FormContext);
